// ===========================================
// Header Component
// ===========================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProjects } from '../context/ProjectContext';
import { Search, Plus, Menu, Bell } from 'lucide-react';
import CreateProjectModal from './CreateProjectModal';
import './Header.scss';

const Header = ({ onMenuClick }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { fetchProjects } = useProjects();
  const navigate = useNavigate();

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      fetchProjects({ search: searchQuery });
    }
  };

  // Handle project created
  const handleProjectCreated = (project) => {
    setShowCreateModal(false);
    navigate(`/dashboard/projects/${project._id}`);
  };

  return (
    <header className="header">
      {/* Mobile Menu Button */}
      <button className="header__menu-btn" onClick={onMenuClick}>
        <Menu size={20} />
      </button>

      {/* Search Bar */}
      <form className="header__search" onSubmit={handleSearch}>
        <Search size={18} className="header__search-icon" />
        <input
          type="text"
          placeholder="Search projects, tags, tech stack..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="header__search-input"
        />
      </form>

      {/* Actions */}
      <div className="header__actions">
        {/* Notifications */}
        <button className="header__action-btn">
          <Bell size={20} />
          <span className="header__notification-badge">3</span>
        </button>

        {/* Create Project Button */}
        <button 
          className="header__create-btn btn-primary"
          onClick={() => setShowCreateModal(true)}
        >
          <Plus size={18} />
          <span>New Project</span>
        </button>
      </div>

      {/* Create Project Modal */}
      {showCreateModal && (
        <CreateProjectModal
          onClose={() => setShowCreateModal(false)}
          onCreated={handleProjectCreated}
        />
      )}
    </header>
  );
};

export default Header;

